import Vue from 'vue'
import VeeValidate from 'vee-validate'
import form from './form'

const VueValidationEs = require('vee-validate/dist/locale/es');

const nif = {
  validate(value) {
    if(form.validateCIF(value)){
      return true
    }

    if(form.validateNIF(value)){
      return true
    }else{
      return false
    }
  }
};

const iban = {
  validate(value) {
    if(form.checkIBAN(value)){
      return true
    }else{
      return false
    }
  }
};

const phone = {
  validate(value) {
    if(form.phone(value)){
      return true
    }else{
      return false
    }
  }
};

const partnerBirthdate = {
  validate(value) {
    if (form.validatePartnerBirthdate(value)) {
      return true;
    } else {
      return false;
    }
  }
};

const autonomousRegisteredAt = {
  validate(value, args) {
    if (form.validateAutonomousRegisteredAt(value, args.birthday)) {
      return true;
    } else {
      return false;
    }
  }
};

const registeredAt = {
  validate(value, args) {
    if (form.validateRegisteredAt(value, args.autonomousRegisteredAt)) {
      return true;
    } else {
      return false;
    }
  }
};

const paidUntil = {
  validate(value, args) {
    if (form.validatePaidUntil(value, args.birthday)) {
      return true;
    } else {
      return false;
    }
  }
}

VeeValidate.Validator.extend('iban', iban);
VeeValidate.Validator.extend('nif', nif);
VeeValidate.Validator.extend('phone', phone);
VeeValidate.Validator.extend('partnerBirthdate', partnerBirthdate);
VeeValidate.Validator.extend('autonomousRegisteredAt', autonomousRegisteredAt);
VeeValidate.Validator.extend('registeredAt', registeredAt);
VeeValidate.Validator.extend('paidUntil', paidUntil);

Vue.use(VeeValidate, 
  {
    locale: 'es',
    dictionary: {
      es: {
        messages: {
          ...VueValidationEs.messages,
          partnerBirthdate: 'El usuario debe ser mayor de 18 años',
          autonomousRegisteredAt: 'El usuario debe ser mayor de 18 años',
          registeredAt: 'La fecha de alta en ATA debe ser posterior a la fecha de alta de autonomo',
          phone: 'Campo teléfono es incorrecto',
          iban: 'Campo IBAN es incorrecto',
          nif: 'Campo NIF es incorrecto',
          paidUntil: 'Campo pagado hasta anterior a fecha de nacimiento',
        }
      }
    },
    inject: true,
    // important to name this something other than 'fields'
    fieldsBagName: 'veeFields'
  }
);
